import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 350px;
  height: 300px;
  background: linear-gradient(180deg, #56f096 0%, #5db1ea 100%);
  border-radius: 10px;
  text-align: center;
  box-shadow: 1px 5px 10px rgba(37, 35, 35, 0.25);
  padding: 0 30px;
  transition: 1s;

  @media (max-width: 1200px) {
    max-width: 300px;
    height: 250px;
  }
`

const Title = styled.h1`
  font-weight: bold;
  font-size: 30px;
  line-height: 36px;
  transition: 1s;

  @media (max-width: 1200px) {
    font-size: 24px;
  }
`

const Text = styled.p`
  font-size: 20px;
  line-height: 140%;
  transition: 1s;

  @media (max-width: 1200px) {
    font-size: 16px;
  }
`

const FeatureCard = (props) => (
  <Wrapper>
    <Title>{props.title}</Title>
    <Text>{props.text}</Text>
  </Wrapper>
)

FeatureCard.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
}

FeatureCard.propTypes = {
  title: PropTypes.node.isRequired,
  text: PropTypes.node.isRequired,
}

export default FeatureCard
